//Parroquias Aragua
const munBolivar = ['Capital Bolívar'];
const munCamatagua = ['Camatagua', 'No Urbana Carmen De Cura'];
const munGirardot = [
  'No Urbana Choroní',
  'Urbana Las Delicias',
  'Urbana Madre María de San José',
  'Urbana Joaquín Crespo',
  'Urbana Pedro José Ovalles',
  'Urbana José Casanova Godoy',
  'Urbana Andrés Eloy Blanco',
  'Urbana Los Tacariguas',
];
const munJoseAngelLamas = ['José Angel Lamas'];
const munJoseFelixRibas = [
  'Urbana Juan Vicente Bolívar y Ponte',
  'Urbana Castor Nieves Ríos',
  'No Urbana Las Guacamayas',
  'No Urbana Pao de Zárate',
  'No Urbana Zuata',
];
const munJoseRafaelRevenga = ['José Rafael Revenga'];
const munLibertador = ['Libertador', 'No Urbana San Martín de Porres '];
const munMarioBricenoIragorry = [
  'Mario Briceño Iragorry',
  'Urbana Caña de Azúcar',
];
const munSanCasimiro = [
  'San Casimiro',
  'No Urbana Güiripa',
  'No Urbana Ollas de Caramacate',
  'No Urbana Valle Morín',
];
const munSanSebastian = ['San Sebastian'];
const munSantiagoMarino = [
  'Santiago Mariño',
  'No Urbana Arévalo Aponte',
  'No Urbana Chuao',
  'No Urbana Samán de Güere',
  'No Urbana Alfredo Pacheco Miranda',
];
const munSantosMichelena = ['Santos Michelena ', 'No Urbana Tiara'];
const munSucre = ['Sucre', 'No Urbana Bella Vista'];
const munTovar = ['Capital Tovar'];
const munUrdaneta = [
  'Urdaneta',
  'No Urbana Las Peñitas',
  'No Urbana San Francisco de Cara',
  'No Urbana Taguay',
];
const munZamora = [
  'Zamora',
  'No Urbana Magdaleno',
  'No Urbana San Francisco de Asís',
  'No Urbana Valles de Tucutunemo',
  'No Urbana Augusto Mijares',
];
const munFranciscoLinaresAlcantara = [
  'Francisco Linares Alcántara',
  'No Urbana Francisco de Miranda',
  'No Urbana Monseñor Feliciano González',
];
const munOcumareCosta = ['Ocumare De La Costa'];

export const esAragua = [
  {
    municipio: 'Bolívar',
    parroquias: munBolivar,
  },
  {
    municipio: 'Camatagua',
    parroquias: munCamatagua,
  },
  {
    municipio: 'Girardot',
    parroquias: munGirardot,
  },
  {
    municipio: 'José Angel Lamas',
    parroquias: munJoseAngelLamas,
  },
  {
    municipio: 'José Felix Ribas',
    parroquias: munJoseFelixRibas,
  },
  {
    municipio: 'José Rafael Revenga',
    parroquias: munJoseRafaelRevenga,
  },
  {
    municipio: 'Libertador',
    parroquias: munLibertador,
  },
  {
    municipio: 'Mario Briceño Iragorry',
    parroquias: munMarioBricenoIragorry,
  },
  {
    municipio: 'San Casimiro',
    parroquias: munSanCasimiro,
  },
  {
    municipio: 'San Sebastian',
    parroquias: munSanSebastian,
  },
  {
    municipio: 'Santiago Mariño',
    parroquias: munSantiagoMarino,
  },
  {
    municipio: 'Santos Michelena',
    parroquias: munSantosMichelena,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucre,
  },
  {
    municipio: 'Tovar',
    parroquias: munTovar,
  },
  {
    municipio: 'Urdaneta',
    parroquias: munUrdaneta,
  },
  {
    municipio: 'Zamora',
    parroquias: munZamora,
  },
  {
    municipio: 'Francisco Linares Alcántara',
    parroquias: munFranciscoLinaresAlcantara,
  },
  {
    municipio: 'Ocumare De La Costa De Oro',
    parroquias: munOcumareCosta,
  },
];
